import create, { GetState, SetState } from 'zustand';

interface ICourseStore {
  activeParagraph: number;
  setActiveParagraph: (activeParagraph: number) => void;
}

const store = (set: SetState<ICourseStore>, get: GetState<ICourseStore>) => ({
  activeParagraph: 0,
  setActiveParagraph: (activeParagraph: number) => {
    set({ activeParagraph });
  },
});

export const useCourseStore = create<ICourseStore>(store);
